import React from 'react'
import { BorderSpec } from '~/models'
import { memo } from '~/ui/component'
import { Label, HBox, SelectField, SelectFieldProps } from '~/ui/components'
import { Choice } from '~/ui/components/fields/SelectField'
import { layout } from '~/ui/styling'
import { useBranding } from '../BrandingContext'
import BrandingBorderSwatch from './BrandingBorderSwatch'

export type Props = Omit<SelectFieldProps<string>, 'choices'>

const BrandingBorderField = memo('BrandingBorderField', (props: Props) => {

  const {branding} = useBranding()

  //------
  // Rendering

  function render() {
    return (
      <SelectField
        {...props}
        choices={choices}
      />
    )
  }

  const renderNamedBorder = React.useCallback((name: string, spec: BorderSpec, list: boolean) => {
    return (
      <HBox padding={list ? layout.padding.inline.m : 0} gap={layout.padding.inline.m}>
        <BrandingBorderSwatch name={name}/>
        <Label flex mono>
          {name}
        </Label>
      </HBox>
    )
  }, [])

  const choices = React.useMemo((): Choice<string>[] => {
    return Object.entries(branding?.borders ?? {}).map(([name, spec]) => ({
      value:  name,
      render: list => renderNamedBorder(name, spec, list),
    }))
  }, [branding?.borders, renderNamedBorder])

  return render()

})

export default BrandingBorderField